/** Local visual examples from Page01 delivery v2.0; never a backend contract. */
export const page01Example = {
  version: '2.0',
  classification: 'DESIGN_ONLY',
  context: {
    region: '示范区域',
    time: '2024-11-15 10:24',
    title: 'AI消防+救援 综合态势首页',
    subtitle: 'National Overview',
  },
  navigation: [
    '综合态势',
    '风险与预警',
    '场景中心',
    '救援任务工作台',
    '能力与装备中心',
    '技术 / 解决方案生态',
    '知识 / 演练 / 复盘',
    '治理与系统配置',
  ],
  metrics: [
    { label: '当前事件', value: '7', detail: '当前范围 · 示例', icon: 'flame', color: 'red' },
    { label: '预警信息', value: '23', detail: '当前范围 · 示例', icon: 'alert', color: 'orange' },
    {
      label: '重点风险点位',
      value: '1,268',
      detail: '已登记点位 · 示例',
      icon: 'pin',
      color: 'blue',
    },
    {
      label: '消防站点',
      value: '320',
      detail: '已登记站点 · 示例',
      icon: 'building',
      color: 'green',
    },
  ],
  events: [
    {
      id: 'demo-01',
      name: '主城区商业楼火警',
      location: '主城区',
      type: '建筑火灾',
      state: '处置中',
      time: '11-15 09:42',
      level: '高',
    },
    {
      id: 'demo-02',
      name: '梁港区化工厂泄漏',
      location: '梁港区',
      type: '危险化学品',
      state: '已出动',
      time: '11-15 08:15',
      level: '高',
    },
    {
      id: 'demo-03',
      name: '北部山区火情',
      location: '北部片区',
      type: '森林火灾',
      state: '持续监测',
      time: '11-15 07:28',
      level: '中',
    },
    {
      id: 'demo-04',
      name: '东部工业区火警',
      location: '东部片区',
      type: '工业火灾',
      state: '已控制',
      time: '11-14 22:16',
      level: '中',
    },
    {
      id: 'demo-05',
      name: '沿海仓储火灾',
      location: '沿海片区',
      type: '仓储火灾',
      state: '处置中',
      time: '11-14 19:03',
      level: '中',
    },
  ],
  readiness: [
    {
      label: '人员准备率',
      value: 86,
      icon: 'users',
      detail: [
        ['在编', '12,680'],
        ['值班队伍', '158'],
      ],
    },
    {
      label: '车辆 / 装备准备率',
      value: 78,
      icon: 'truck',
      detail: [
        ['在营', '2,445'],
        ['主要装备', '735'],
      ],
    },
    {
      label: '基础设施准备率',
      value: 91,
      icon: 'building',
      detail: [
        ['消防站', '320'],
        ['指挥中心', '12'],
      ],
    },
    {
      label: '指挥通信准备率',
      value: 88,
      icon: 'radio',
      detail: [
        ['通信系统', '100%'],
        ['指挥专网', '正常'],
      ],
    },
  ],
  scenarios: [
    { name: '高层建筑火灾', value: 92, icon: 'building', status: '示例评估' },
    { name: '森林火灾', value: 76, icon: 'tree', status: '示例评估' },
    { name: '危化事故', value: null, icon: 'flask', status: '规划展示' },
    { name: '城市综合灾害', value: null, icon: 'city', status: '规划展示' },
  ],
  capability: [
    { name: '灭火救援', value: 92 },
    { name: '指挥调度', value: 88 },
    { name: '通信保障', value: 86 },
    { name: '危化处置', value: 78 },
    { name: '医疗救助', value: 81 },
    { name: '森林灭火', value: 76 },
  ],
  warnings: [
    {
      name: '东部工业区森林火险等级上升',
      level: '重要',
      source: '气象监测',
      region: '东部片区',
      time: '11-15 08:20',
      color: 'red',
    },
    {
      name: '沿海片区强风预警',
      level: '提示',
      source: '气象台',
      region: '沿海片区',
      time: '11-15 06:40',
      color: 'orange',
    },
    {
      name: '主城区高温干旱风险',
      level: '提示',
      source: '应急管理',
      region: '主城区',
      time: '11-15 05:18',
      color: 'orange',
    },
    {
      name: '多地进入秋冬季防火期',
      level: '信息',
      source: '应急管理',
      region: '全域',
      time: '11-14 18:32',
      color: 'blue',
    },
    {
      name: '北部片区雷暴天气预警',
      level: '提示',
      source: '气象台',
      region: '北部片区',
      time: '11-14 16:11',
      color: 'orange',
    },
  ],
  suggestions: [
    {
      name: '高层建筑消防安全检查建议',
      summary: '建议关注重点区域的消防安全检查与隐患排查。',
      icon: 'flame',
      color: 'red',
      action: '查看依据',
    },
    {
      name: '森林火险关注建议',
      summary: '建议关注北部片区火险变化与相关预警信息。',
      icon: 'tree',
      color: 'orange',
      action: '查看依据',
    },
    {
      name: '危化企业风险检查建议',
      summary: '建议查看危化企业风险资料与隐患检查记录。',
      icon: 'flask',
      color: 'orange',
      action: '查看依据',
    },
    {
      name: '秋冬季防火准备建议',
      summary: '建议查看防火宣传、排查与演练准备资料。',
      icon: 'info',
      color: 'blue',
      action: '查看详情',
    },
  ],
  trend: {
    metric: '事件数量（起）',
    range: '2024-11-09—2024-11-15（示例）',
    labels: ['11-09', '11-10', '11-11', '11-12', '11-13', '11-14', '11-15'],
    values: [10, 16, 18, 23, 22, 27, 32],
    note: '原图未标逐点值；按已确认母版走势整理的视觉示例，不是原始统计数据。',
  },
  shortcuts: [
    { name: '新增事件报告', icon: 'siren' },
    { name: '资源调度', icon: 'clipboard' },
    { name: '力量布防', icon: 'users' },
    { name: '演练管理', icon: 'map' },
    { name: '数据研判', icon: 'chart' },
    { name: '应急预案', icon: 'file' },
    { name: '培训管理', icon: 'book' },
    { name: '数据报表', icon: 'report' },
    { name: '系统管理', icon: 'settings' },
  ],
} as const;
